export default (props, vars) =>
  `${vars?.['usestate13']?.['state'].length} Selected`;
